import React from 'react'
import {
  MenuItem,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
  InputLabel,
  Select,
} from '@material-ui/core'
import { Close, ExpandMore } from '@material-ui/icons'
import { Controller, useFormContext } from 'react-hook-form'

import useStyles from './styles'

const SelectMapComponent = ({ name, label, item = [] }) => {
  const classes = useStyles()

  const { control, errors, watch, setValue } = useFormContext()
  const currentValue = watch(name)

  return (
    <>
      <Grid item xs={6}>
        <InputLabel className={classes.label}>{label} (opcional)</InputLabel>
        <Controller
          defaultValue=""
          as={
            <Select
              IconComponent={ExpandMore}
              className={classes.input}
              variant="outlined"
              fullWidth
              displayEmpty
              error={!!errors[name]}
              endAdornment={
                currentValue ? (
                  <InputAdornment
                    position="end"
                    className={classes.clearAdornment}
                  >
                    <IconButton
                      size="small"
                      onClick={() => setValue(name, '')}
                      onMouseDown={(event) => event.stopPropagation()}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }
              renderValue={(selected) => {
                const selectedItem = item?.find(
                  (currentItem) =>
                    (currentItem?.value || currentItem?.id) === selected,
                )
                if (!selectedItem) {
                  return null
                }
                return (
                  <Typography className={classes.menuItem}>
                    {selectedItem?.name}
                  </Typography>
                )
              }}
            >
              {item?.map((item) => (
                <MenuItem
                  key={item?.value || item?.id}
                  value={item?.value || item?.id}
                >
                  <Typography className={classes.menuItem}>
                    {item?.name}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          }
          control={control}
          name={name}
        />
      </Grid>
    </>
  )
}

export default SelectMapComponent
